import React, { useState, useRef, useEffect } from 'react';
import styles from '../styles/InputSection.module.css';

function InputSection({ onSendMessage, isLoading, prefilledValue = '', onPrefilledClear }) {
  const [message, setMessage] = useState('');
  // Drives the send micro-animation (arrow flies off, input lifts) — instant
  // feedback that the message left, since the reply itself takes seconds.
  const [justSent, setJustSent] = useState(false);
  const textareaRef = useRef(null);

  // Set prefilled value when it changes
  useEffect(() => {
    if (prefilledValue) {
      setMessage(prefilledValue);
    }
  }, [prefilledValue]);

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [message]);

  const handleSend = async () => {
    if (!message.trim() || isLoading) return;

    const outgoing = message;
    // Clear IMMEDIATELY and play the send animation. The old code cleared
    // after the await — the user's text sat greyed-out in the box for the
    // whole 10-20s round trip, which read as "did that even send?".
    setMessage('');
    setJustSent(true);
    setTimeout(() => setJustSent(false), 700);

    try {
      await onSendMessage(outgoing);
    } catch (e) {
      // Send failed — put the text back so nothing typed is lost.
      setMessage(outgoing);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className={styles.inputSection} data-tour="input-section">
      <div className={styles.inputSectionContent}>
        <div className={styles.inputContainer}>
          <textarea
            ref={textareaRef}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Message..."
            /* a placeholder is not an accessible name — without this the
               app's primary input announces as an unnamed edit field */
            aria-label="Message Sophia"
            className={styles.textarea}
            disabled={isLoading}
            rows={1}
          />
          <button
            onClick={() => handleSend()}
            className={`${styles.sendButton} ${justSent ? styles.sendButtonSent : ''}`}
            disabled={isLoading || !message.trim()}
            title="Send message"
            aria-label="Send message"
          >
            <span className={styles.sendGlyph} aria-hidden="true">➤</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default InputSection;
